export default {
  en: {
    title: 'Queues history',
    subtitle: 'List of queues.',
    tab: 'Queues',
    callsTab: 'Calls',
    departmentDeleted: 'Segment was deleted',
    queueDetail: 'Queue detail',
    filters: {
      status: 'Status',
      durationPlaceholder: 'Duration (min)',
    },
    columns: {
      department: 'Segment',
      agent: 'Agent',
      date: 'Date',
      duration: 'Wait time',
      status: 'Status',
    },
    view: {
      title: 'Queue detail',
      waitTime: 'Wait time',
      status: 'Status',
      abandonReason: 'Abandon reason',
      ticket: 'Ticket',
      convertedCall: 'Converted call',
      viewCall: 'View call',
      interactionHistory: 'Interaction history',
      acdHistory: 'ACD History',
      assigned: 'Assigned',
      dismissed: 'Dismissed',
      canceled: 'Abandoned',
      waiting: 'In queue',
      answered: 'Answered',
      timeout: 'Timeout',
      agentStates: {
        title: 'Agents by state',
        hint: 'Agents of this segment (not the whole account) in each state when the customer joined the queue.',
        connected: 'Connected',
        available: 'Available',
        inCall: 'In call',
        busy: 'Busy',
        disconnected: 'Disconnected',
        empty: 'No agents',
        unknown: 'Deleted agent',
      },
    },
  },
  es: {
    title: 'Historial de colas',
    subtitle: 'Listado de colas.',
    tab: 'Colas',
    callsTab: 'Llamadas',
    departmentDeleted: 'El segmento fue eliminado',
    queueDetail: 'Detalle de la cola',
    filters: {
      status: 'Estado',
      durationPlaceholder: 'Duración (min)',
    },
    columns: {
      department: 'Segmento',
      agent: 'Agente',
      date: 'Fecha',
      duration: 'Tiempo en cola',
      status: 'Estado',
    },
    view: {
      title: 'Detalle de la cola',
      waitTime: 'Tiempo en cola',
      status: 'Estado',
      abandonReason: 'Razón de abandono',
      ticket: 'Ticket',
      convertedCall: 'Llamada generada',
      viewCall: 'Ver llamada',
      interactionHistory: 'Historial de interacción',
      acdHistory: 'Historial ACD',
      assigned: 'Asignada',
      dismissed: 'Rechazada',
      canceled: 'Abandonada',
      waiting: 'En cola',
      answered: 'Atendida',
      timeout: 'Tiempo agotado',
      agentStates: {
        title: 'Agentes por estado',
        hint: 'Agentes de este segmento (no de toda la cuenta) en cada estado cuando el cliente ingresó a la cola.',
        connected: 'Conectados',
        available: 'Disponibles',
        inCall: 'En llamada',
        busy: 'Ocupados',
        disconnected: 'Desconectados',
        empty: 'Sin agentes',
        unknown: 'Agente eliminado',
      },
    },
  },
  fr: {
    title: 'Historique des files d\'attente',
    subtitle: 'Liste des files d\'attente.',
    tab: 'Files d\'attente',
    callsTab: 'Appels',
    departmentDeleted: 'Le segment a été supprimé',
    queueDetail: 'Détail de la file d\'attente',
    filters: {
      status: 'Statut',
      durationPlaceholder: 'Durée (min)',
    },
    columns: {
      department: 'Segment',
      agent: 'Agent',
      date: 'Date',
      duration: 'Temps d\'attente',
      status: 'Statut',
    },
    view: {
      title: 'Détail de la file d\'attente',
      waitTime: 'Temps d\'attente',
      status: 'Statut',
      abandonReason: 'Raison d\'abandon',
      ticket: 'Ticket',
      convertedCall: 'Appel généré',
      viewCall: 'Voir l\'appel',
      interactionHistory: 'Historique d\'interaction',
      acdHistory: 'Histoire de l\'ACD',
      assigned: 'Assignée',
      dismissed: 'Rejeté',
      canceled: 'Abandonné',
      waiting: 'En file',
      answered: 'Répondu',
      timeout: 'Délai expiré',
      agentStates: {
        title: 'Agents par état',
        hint: 'Agents de ce segment (pas de tout le compte) dans chaque état lorsque le client a rejoint la file.',
        connected: 'Connectés',
        available: 'Disponibles',
        inCall: 'En appel',
        busy: 'Occupés',
        disconnected: 'Déconnectés',
        empty: 'Aucun agent',
        unknown: 'Agent supprimé',
      },
    },
  },
};
